import { useLocation } from "react-router-dom";
import KeepAliveWrapper from "../pages/KeepAliveWrapper";
import Reporttable from "../pages/reportscreen/Reporttable";


const DynamicReportWrapper = () => {
  const location = useLocation();
  const id = `dynamicreport-${location.key}`;

  console.log("KeepAlive ID:", id);
  return (
    <KeepAliveWrapper id={id}>
      <Reporttable />
    </KeepAliveWrapper>
  );
};

export default DynamicReportWrapper;